import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import {
  HasDeleteAccess,
  HasWriteAccess,
  IsSuperUser,
} from "../../../../../../../_metronic/_helpers/AccessControlHelpers";
import { INVESTIGATION_MODEL } from "../../../../../../../_metronic/_helpers/AppModels";
import { CellContentType, RowType, UserType } from "./types";

export function ActionsColumnFormatter(
  cellContent: CellContentType | undefined,
  row: RowType,
  rowIndex: number,
  {
    user,
    deleteInvestigationButtonClick,
  }: { user: UserType; deleteInvestigationButtonClick: (id: string) => void }
) {
  return (
    <>
      {(HasDeleteAccess(user, INVESTIGATION_MODEL) || IsSuperUser(user)) && (
        <a
          onClick={() => deleteInvestigationButtonClick(row.id)}
          title="حذف فاکتور"
          className="btn btn-icon btn-light btn-hover-danger btn-sm"
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            {/* @ts-ignore */}
            <SVG
              title={"حذف فاکتور"}
              src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
            />
          </span>
        </a>
      )}
    </>
  );
}
